import { render } from "./product-badge.vue?vue&type=template&id=a5328fa0"
import script from "./product-badge.vue?vue&type=script&lang=js"
export * from "./product-badge.vue?vue&type=script&lang=js"

import "./product-badge.vue?vue&type=style&index=0&id=a5328fa0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__